/* eslint-disable @typescript-eslint/naming-convention */
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Router } from '@angular/router';
import { Platform } from '@ionic/angular';
import { Observable } from 'rxjs';
import { tap, finalize } from 'rxjs/operators';
import { AuthResponse } from './auth-response';
import { CreditoDebito } from './creditodebito';
import { Imagem } from './imagem';
import { Ocorrencia } from './ocorrencia';
import { Requisicao } from './requisicao';
import { Usuario } from './usuario';
import { Veiculo } from './veiculo';

import { Preferences } from '@capacitor/preferences';
import { UIService } from './ui.service';

@Injectable({
  providedIn: 'root'
})
export class CVCService {
  bLoggedIn = false;
  oLoggedUser: AuthResponse = null;

  // authState = new BehaviorSubject<AuthResponse>(null);
  STORAGE_KEY = 'ACCESS_USER';

  AUTH_SERVER_ADDRESS = 'https://www2.admtransito.com.br/admtt/cvc';


  constructor(private router: Router,
    private httpClient: HttpClient,
    //private storage: Storage,
    private platform: Platform,
    private ui: UIService
  ) {

    this.platform.ready().then(() => {
      // this.ifLoggedIn();
    });

  }

  ifLoggedIn() {

    return Preferences.get({ key: this.STORAGE_KEY }).then(
      data => {
        this.oLoggedUser = JSON.parse(data.value);
        if (this.oLoggedUser != null) {
          this.bLoggedIn = true;
          // console.log(' Estou  logado ');
        } else {
          this.bLoggedIn = false;
          // console.log(' Não Estou  logado ');
        }
      },
      error => {
        this.oLoggedUser = null;
        this.bLoggedIn = false;
      }
    );
  }

  logout() {
    Preferences.remove({ key: this.STORAGE_KEY });
    // this.authState.next(null);
    this.bLoggedIn = false;
    // console.log('logout');
    // this.router.navigateByUrl('/login');
  }

  isLoggedIn() {
    return this.bLoggedIn;
    // return this.authState.value;
  }

  request(method: string, action: string, body: any, setusario = true) {

    let headers = new HttpHeaders({ 'Content-Type': 'application/json', Accept: 'application/json' });
    let url = this.AUTH_SERVER_ADDRESS + '/' + action;

    if (body == null) {
      body = {};
    }

    // const login = this.isLoggedIn();
    let bCredendials = false;

    //console.log(this.oLoggedUser);


    if (this.oLoggedUser !== null) {
      bCredendials = true;
      headers = headers.set('Authorization', this.oLoggedUser.user.access_type + ' ' + this.oLoggedUser.user.access_token);
      body.orgaoid = this.oLoggedUser.user.orgaoid;
      if (setusario) {
        body.usuid = this.oLoggedUser.user.id;
      }
    } else {
      body.orgaoid = '268610';
    }
    url = url.replace('$usuid', body.usuid);

    // console.log(url);
    const requestOptions = { body, headers };
    //console.log(requestOptions);
    //this.ui.showLoader();
    return this.httpClient.request(method, url, requestOptions).pipe(
      tap((ev: any) => {
        //console.log(ev);
        if (ev.quit) {
          this.logout();
          this.router.navigateByUrl('/login');
        }
      }
      ),
      finalize(() => {
        //this.ui.hideLoader();
      })
    );
  }

  login(user: Usuario): Observable<any> {
    return this.request('POST', 'login/', user).pipe(
      tap((res: AuthResponse) => {
        if (res.user) {

          Preferences.set({
            key: this.STORAGE_KEY,
            value: JSON.stringify(res)
          });
          this.oLoggedUser = res;
          this.bLoggedIn = true;
          // console.log('loguei');
        }
      })
    );
  }

  registrar(user: Usuario, update: boolean = false): Observable<any> {
    if (update) {
      return this.request('PUT', 'usuario/$usuid/', user);
    } else {
      return this.request('POST', 'usuario/', user);
    }
  }

  recuperarSenha(pemail): Observable<any> {
    const params = { email: pemail };
    return this.request('POST', 'senha/reset/', params);
  }

  alterarsenha(dados: any): Observable<any> {
    return this.request('POST', 'senha/update/', dados);
  }

  getUsuario(): Observable<any> {
    return this.request('POST', 'usuario/$usuid/lista/', null);
  }

  regVeiculos(veic: Veiculo): Observable<any> {
    return this.request('POST', 'usuario/$usuid/veiculo/', veic);
  }

  delVeiculos(id): Observable<any> {
    return this.request('DELETE', `usuario/$usuid/veiculo/${id}/`, null);
  }

  getVeiculos(veic: Veiculo): Observable<any> {
    return this.request('POST', 'usuario/$usuid/veiculo/lista/', veic);
  }

  regRequisicao(req: Requisicao): Observable<any> {
    return this.request('POST', 'usuario/$usuid/requisicao/', req);
  }

  cancelarRequisicao(id): Observable<any> {
    return this.request('DELETE', `usuario/$usuid/requisicao/${id}/`, null);
  }

  getRequisicoes(req: Requisicao): Observable<any> {
    return this.request('POST', 'usuario/$usuid/requisicao/lista/', req);
  }

  getOcorrenciasUsuario(ocorr: Ocorrencia): Observable<any> {
    return this.request('POST', 'ocorrencia/lista/', ocorr);
  }

  getOcorrencia(id): Observable<any> {
    return this.request('POST', `ocorrencia/${id}/`, null, false);
  }

  getImagens(img: Imagem): Observable<any> {
    return this.request('POST', 'ocorrencia/imagens/', img);
  }

  getCreditosUsuario(cd: CreditoDebito): Observable<any> {
    return this.request('POST', 'usuario/$usuid/credito/lista/', cd);
  }

  getCredito(id): Observable<any> {
    return this.request('POST', `credito/${id}/`, null, false);
  }

  gerarGuia(cd: any): Observable<any> {
    return this.request('POST', 'usuario/$usuid/guia/gerar/', cd);
  }

  showGuia(cd: CreditoDebito) {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json', Accept: 'application/json' });
    const url = this.AUTH_SERVER_ADDRESS + `/usuario/${cd.usuid}/guia/${cd.id}/`;
    this.ui.showRemoteFile(url);
    // return this.request('POST', 'usuario/$usuid/guia/gerar/', cd);
  }

  ativarUsuario(tokenid): Observable<any> {
    return this.request('GET', `usuario/ativar/${tokenid}/`, null);
  }

  validarSolicitacao(tipo, tokenid): Observable<any> {
    return this.request('GET', `solicitacao/${tipo}/${tokenid}/`, null);
  }

  getEstados(): Observable<any> {
    return this.request('GET', 'estados/', null);
  }

  getMunicipios(uf: string): Observable<any> {
    return this.request('GET', `municipios/${uf}/`, null);
  }

  getMunicipio(id: string): Observable<any> {
    return this.request('GET', `municipio/${id}/`, null);
  }

  getTarifa(dados: any): Observable<any> {
    return this.request('POST', `tarifa/`, dados);
  }

  getTipoRequerente(dados: any): Observable<any> {
    return this.request('POST', 'tiporequerente/', dados);
  }

  validarIsencao(dados: any): Observable<any> {
    return this.request('POST', `valida/isencao/`, dados);
  }


}
